import { render, staticRenderFns } from "./BeyondWork.vue?vue&type=template&id=a4529828&scoped=true"
import script from "./BeyondWork.vue?vue&type=script&lang=js"
export * from "./BeyondWork.vue?vue&type=script&lang=js"
import style0 from "./BeyondWork.vue?vue&type=style&index=0&id=a4529828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4529828",
  null
  
)

export default component.exports